import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]
  static values = { open: Boolean }

  connect() {
    this.timeout = null
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }

  show() {
    if (this.timeout) clearTimeout(this.timeout)
    this.openValue = true
    this.menuTarget.classList.remove("hidden")
  }

  hide() {
    if (this.timeout) clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.openValue = false
      this.menuTarget.classList.add("hidden")
    }, 200)
  }

  toggle() {
    if (this.openValue) {
      this.hide()
    } else {
      this.show()
    }
  }
}
